var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOthrsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.617,
    height: 24.496,
    viewBox: "0 0 24.617 24.496",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M9.475,5.191h0A3.066,3.066,0,1,0,5.067.928L3.846,2.188A13.24,13.24,0,0,0,2.612,19.4a13.208,13.208,0,0,0,1.28,1.439,12.989,12.989,0,0,0,18.371-.31l1.491-1.544a3.066,3.066,0,0,0-4.408-4.263l-1.491,1.544A6.867,6.867,0,0,1,7.172,15.241a7,7,0,0,1,.99-8.677L9.495,5.184H9.488Z",
    transform: "translate(0.002 0.007)",
    fill: "#b9b9b9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthrsIcon);
export default __webpack_public_path__ + "static/media/othrsIcon.14d669ff12a340da4130b767b4989534.svg";
export { ForwardRef as ReactComponent };